import { useSelector } from "react-redux";

import logoFallback from "assets/logo/letter.png";
import logoDarkFallback from "assets/logo/letter.png";
import { baseURL } from "config/environment";

const useLogo = () => {
  let _logo = useSelector(state => state.ui.theme.logo);
  let _darkLogo = useSelector(state => state.ui.theme.darkLogo);

  let _loginBannerLogo = useSelector(
    state => state.ui.theme.mc_login_banner_logo
  );

  _logo = !!_logo ? baseURL + _logo : "";
  _darkLogo = !!_darkLogo ? baseURL + _darkLogo : "";
  _loginBannerLogo = !!_loginBannerLogo ? baseURL + _loginBannerLogo : "";

  const logo = _logo || _darkLogo || logoFallback;
  const darkLogo = _darkLogo || _logo || logoDarkFallback;
  const loginBannerLogo = _loginBannerLogo;

  return { logo, darkLogo, loginBannerLogo };
};

export default useLogo;
